module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/5mill-active-afcf2a5f8eb04ad3e3e0ab71b0c73c36.png";